// utils.js — Общие утилиты БРОНИДОМ
// Подключать ПОСЛЕ error-handler.js, ПЕРЕД остальными скриптами
// Убирает дублирование escHtml, formatPrice, ymGoal между файлами

(function(){
  'use strict';

  // Пара корпуса из события генплана одинакова для витрины и фильтра карточки/группы.
  window.broniGenplanCorpusFilter = function(detail) {
    var section = detail && typeof detail.section === 'string' ? detail.section : '';
    var numbers = section && typeof detail.sectionNumbers === 'string' ? detail.sectionNumbers : '';
    return { section: section, sectionNumbers: numbers };
  };

  // ── HTML Escape (XSS prevention) ─────────────────────────
  // Была продублирована в: article.js, cabinet.js, jk.js, map.js, mortgage-page.js
  window.escHtml = function(s) {
    if (s == null) return '';
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  };

  /* ── СТЕНДОВАЯ КАЛИТКА КАРТИНОК — ОДНА НА ВЕСЬ САЙТ ──────────────────────
     (доводка 4 блока 2.1 плана local-stand, 10.09.2026)

     ⛔ ЗАЧЕМ ОНА ЗДЕСЬ, А НЕ В КАЖДОМ ФАЙЛЕ. Отрисовщиков картинок в
     `public/js` три десятка, и у большинства своего уменьшителя нет. Без общей
     калитки каждый закрытый файл заводил бы СВОЮ копию правила «как построить
     адрес миниатюры» — это находка 30 («политика картинок живёт в пяти копиях»),
     помноженная на десять. Поэтому копия ровно одна и лежит тут; файлы её
     только зовут: `var standSrc = function (u, w) { return window.standSrc ? window.standSrc(u, w) : u; };`

     ⛔ ЧТО ОНА ДЕЛАЕТ НА ПРОДЕ. Ничего. Первая же строка возвращает адрес как
     есть, если флага стенда нет: на проде `window.BRONIDOM_STAND` — `false`,
     вне шаблона — `undefined`, сравнение строгое. То есть на боевом сайте
     `standSrc(u, w)` — это `u`, байт в байт, и прод-политику картинок
     (пять `thumbUrl()` в отрисовщиках) она не трогает вовсе.

     ⛔ ЧТО ОНА ДЕЛАЕТ НА СТЕНДЕ. Уводит адрес в свой `/img-thumb.php`, а тот
     (StandMedia) наружу не ходит: отдаёт привезённую копию либо честную
     заглушку. Относительные адреса не трогаем — они и так наши.
     ────────────────────────────────────────────────────────────────────── */
  window.standSrc = window.standSrc || function(url, w) {
    if (window.BRONIDOM_STAND !== true) return url;
    if (!url || typeof url !== 'string') return url || '';
    if (!/^https?:\/\//i.test(url)) return url;
    return '/img-thumb.php?src=' + encodeURIComponent(url) + '&w=' + (w || 1200);
  };

  // ── Safe Color (CSS injection prevention) ───────────────
  // Phase D follow-up: вынесено из map.js, чтобы не дублировать в catalog.js,
  // jk.js, flat.js. Принимает только #RGB / #RRGGBB / #RRGGBBAA, иначе fallback.
  // Защищает от 'red); background:url(//evil.com)' инъекций в style="background:".
  window.safeColor = function(c, fallback) {
    if (fallback == null) fallback = '#888';
    return /^#[0-9a-f]{3,8}$/i.test(String(c || '')) ? String(c) : fallback;
  };

  // ── Safe URL (XSS prevention via javascript:/data:/vbscript:) ────
  // jk-audit 2026-05-04 #1: video_url из БД может содержать `javascript:alert(1)`.
  // esc() HTML-кодирует <>"&, но не блокирует javascript:. Whitelist схем:
  // http/https/mailto/tel + относительные пути (// или /). Anchored regex (\A...\z).
  window.safeUrl = function(url, fallback) {
    if (fallback == null) fallback = '';
    var s = String(url == null ? '' : url).trim();
    if (s === '') return fallback;
    // Относительные пути: /path или //host/path
    if (/^\//.test(s)) return s;
    // Абсолютные URL: только http(s), mailto, tel
    if (/^(https?:\/\/|mailto:|tel:)/i.test(s)) return s;
    return fallback;
  };

  // ── Адрес карточки ЖК (D.1, ADR-091) ─────────────────────
  // Каталог, карта и витрина рисуют карточки целиком на JS, поэтому адрес им нужен
  // здесь. Собирать ЧПУ в браузере НЕЛЬЗЯ: это потребовало бы второй копии таблицы
  // транслита и правил разбивки московских витрин, и они разъехались бы с серверными
  // молча — ссылка вела бы на 404, а не на ошибку.
  //
  // Поэтому адрес приходит ГОТОВЫМ полем `url` из map_api. Фолбэк на старый адрес
  // нужен ровно для окна «код выкачен, слаги ещё не проставлены» и для стейл-кэша
  // выдачи: старый адрес живой и отдаёт 301.
  //
  // ⛔ ВАЙТЛИСТ СХЕМЫ, а не экранирование (ADR-074). Значение приходит из ответа
  // сервера, но попадает в четыре навигационных приёмника (href, window.open,
  // window.location) — а там `javascript:` исполняется, и никакое escaping от
  // этого не спасает. Принимаем ТОЛЬКО путь от корня: `/novostroyki/...`.
  // «//evil.com» отсекается вторым слешем — это протокол-относительный внешний
  // адрес, уводящий человека с сайта.
  window.jkHref = function(item) {
    var url = item && typeof item.url === 'string' ? item.url : '';
    if (url !== '' && url.charAt(0) === '/' && url.charAt(1) !== '/') return url;
    var id = item && item.id ? parseInt(item.id, 10) : 0;
    return '/jk.php?id=' + (id > 0 ? id : 0);
  };

  // ── Форматирование цен ───────────────────────────────────
  // Было 5 разных реализаций: map.js (fP, fPShort), jk.js (fmt), cabinet.js (fmt), catalog.js (inline)

  // Полный формат: 2 435 355 ₽ → «2,4 млн ₽»
  window.formatPrice = function(n) {
    n = +n;
    if (!n) return '—';
    if (n >= 1e9) return (n / 1e9).toFixed(2).replace(/\.?0+$/, '') + ' млрд ₽';
    if (n >= 1e6) return (n / 1e6).toFixed(n % 1e6 ? 1 : 0).replace('.0', '') + ' млн ₽';
    if (n >= 1e3) return ~~(n / 1e3) + ' тыс. ₽';
    return n + ' ₽';
  };

  // Короткий: «2,4 млн» (без ₽, для карточек)
  window.formatPriceShort = function(n) {
    n = +n;
    if (!n) return '—';
    if (n >= 1e6) return (n / 1e6).toFixed(1).replace('.', ',') + ' млн';
    if (n >= 1e3) return ~~(n / 1e3) + ' тыс.';
    return String(n);
  };

  // Числовой с разделителями: 2 435 355
  window.formatNum = function(n) {
    return Math.round(+n || 0).toLocaleString('ru');
  };

  // ── Ипотечный платёж (PMT) ───────────────────────────────
  // Дублировалась в: mortgage-page.js, jk.js
  window.calcMonthly = function(price, downPct, rate, years) {
    var p = price * (1 - downPct / 100);
    var mr = rate / 100 / 12;
    var n = years * 12;
    if (mr === 0) return Math.round(p / n);
    return Math.round(p * (mr * Math.pow(1 + mr, n)) / (Math.pow(1 + mr, n) - 1));
  };

  // ── Яндекс.Метрика — цели ───────────────────────────────
  // Дублировалась в: shared.js, index.js
  if (typeof window.ymGoal === 'undefined') {
    window.ymGoal = function(t, p) {
      try { if (typeof ym === 'function') ym(window.YM_COUNTER_ID, 'reachGoal', t, p || {}); } catch(e) {}
    };
  }

  // ── block #29 (SSOT завершён 2026-07-04): классификатор планировок УДАЛЁН из JS ──
  // Раньше здесь жило name-based зеркало window.BroniLayoutImage (копия PHP-регэкспов
  // FlatLayoutImage: isMiniSchema / isRealFloorplan / isDogmaFloorplanForArea / …).
  // Теперь ЕДИНСТВЕННЫЙ SSOT классификации «план / поэтажник / композит» — PHP-модуль
  // app/lib/Domain/RealEstate/Layout/LayoutPolicy.php. Сервер (FlatHandler::get) кладёт
  // в JSON готовые поля: hero_plan_url (планировка квартиры), hero_plan_typical (метка
  // «типовая»), floor_scheme_url (поэтажник этажа). Клиент их только читает и рисует —
  // не парсит имена файлов. Причина: name-based зеркало не видело широкий композит Догмы
  // (в JS нет размеров картинки — отличить композит можно лишь по aspect ratio, что знает
  // только сервер по кэшу layout_w/h). Потребители: buildOrder ниже + flat-overlay.js.

  // ── 6.1n / block #28 fix-round: hero-галерея квартиры = ТОЛЬКО планировка квартиры ──
  // Владелец 04.07: hero показывает ИСКЛЮЧИТЕЛЬНО планировку квартиры. Поэтажник и фото
  // ЖК из hero УБРАНЫ (они уже есть на странице: фото ЖК — в sticky-rail, поэтажник — в
  // секции «Поэтажный план» ниже).
  //
  // ⚠️ block #28 (P1-A): решение hero-плана принимает СЕРВЕР (FlatHandler::heroPlan) и
  // отдаёт готовое поле flat.hero_plan_url (+ flat.hero_plan_typical). JS БОЛЬШЕ НЕ
  // классифицирует layout_url по имени: name-based классификатор не видит ШИРОКИЙ
  // композит Догмы (план+мини-поэтажник+роза ветров) — в JS нет размеров картинки, а
  // отличить композит от чистого плана можно только по aspect ratio (см. LayoutPolicy).
  // Сервер даёт чистый план (свой/близнец) ИЛИ композит-как-есть, если ничего лучше нет.
  //   • hero_plan_url === ''  → пустой photos → брендовая заглушка «Планировка уточняется»;
  //   • hero_plan_typical      → метка «типовая планировка» (план близнеца/группы).
  // Возвращает { photos:[план]|[], typicalFirst, kinds:['plan']|[], hasPlan }. Чистая функция.
  window.BroniFlatGallery = {
    buildOrder: function(flat) {
      flat = flat || {};
      // Серверное решение — единственный источник (SSOT). Никакой name-based логики.
      var plan = flat.hero_plan_url ? String(flat.hero_plan_url) : '';
      var typicalFirst = !!flat.hero_plan_typical;
      var photos = plan ? [plan] : [];
      // kinds — план всегда 'plan' (белая подложка .flat-plan-img). Фото ЖК/поэтажник
      // в hero не попадают, поэтому 'photo' здесь не бывает.
      var kinds = plan ? ['plan'] : [];
      // Двухуровневые квартиры (Level 31.07): сервер кладёт остальные СВОИ листы плана
      // в hero_plan_extra_urls (лист 2 дуплекса) — тоже 'plan', после основного листа.
      if (plan && Array.isArray(flat.hero_plan_extra_urls)) {
        flat.hero_plan_extra_urls.forEach(function (u) {
          if (u && photos.indexOf(String(u)) === -1) {
            photos.push(String(u));
            kinds.push('plan');
          }
        });
      }
      return { photos: photos, typicalFirst: typicalFirst, kinds: kinds, hasPlan: !!plan };
    }
  };

  // ── Лайтбокс фото (общий) ────────────────────────────────
  // jk-redesign 6.5 DRY: вынесен из flat.js, чтобы каталог (модалка flat-overlay.js
  // «На этаже») переиспользовал ТОТ ЖЕ лайтбокс вместо открытия плана новой вкладкой.
  // НЕ копипаста — единственная реализация здесь; window.openLightbox зовут flat.js,
  // flat-overlay.js и jk-filter-results.js.
  // ⛔ Стили (css/lightbox.css) обязаны ехать на КАЖДОЙ странице, где живёт хоть один из
  // этих трёх — без position:fixed узел встаёт в поток и уезжает за экран («лупа есть,
  // клик не увеличивает», прод 31.07). Список страниц не хардкодим: его выводит
  // tests/Integration/lightbox-css-everywhere.test.mjs из самих $pageJS.
  // U.1 (02.08): flats.php из этого списка ВЫШЛА — вместе с flat-overlay.js, который был
  // там единственным потребителем лайтбокса.
  // ── 6.1l: чистая математика zoom/pan (юнит-тестируется отдельно) ──────
  // Вынесена из замыкания в window.LightboxZoom, чтобы tests/JS могли проверить
  // clamp масштаба и границы пана без DOM. Vanilla, без библиотек.
  var MIN_SCALE = 1, MAX_SCALE = 4;
  var LightboxZoom = {
    MIN_SCALE: MIN_SCALE,
    MAX_SCALE: MAX_SCALE,
    // Ограничение масштаба в [1..4].
    clampScale: function(s) {
      if (Number.isNaN(s)) return MIN_SCALE;
      return Math.min(MAX_SCALE, Math.max(MIN_SCALE, s));
    },
    // Максимальный сдвиг по оси (px) — половина «лишней» (масштабированной) длины
    // относительно исходного видимого размера. При scale<=1 сдвиг запрещён (0).
    maxOffset: function(scale, size) {
      if (scale <= 1 || size <= 0) return 0;
      return (scale - 1) * size / 2;
    },
    // Границы пана: t не даёт увести картинку за пределы (края не «отрываются»).
    clampPan: function(t, scale, size) {
      var m = LightboxZoom.maxOffset(scale, size);
      if (Number.isNaN(t)) return 0;
      return Math.min(m, Math.max(-m, t));
    },
    // Зум к точке (px, относительно центра вьюпорта картинки): точка под курсором
    // остаётся на месте. Возвращает новые {scale, tx, ty} (уже с clampPan).
    zoomToPoint: function(state, factor, px, py, w, h) {
      var ns = LightboxZoom.clampScale(state.scale * factor);
      if (ns === state.scale) {
        return { scale: ns, tx: state.tx, ty: state.ty };
      }
      // content-координата под курсором инвариантна: (px - t)/scale = const.
      var ntx = px - (px - state.tx) * (ns / state.scale);
      var nty = py - (py - state.ty) * (ns / state.scale);
      // при возврате к 1x — строго центр.
      if (ns <= 1) { ntx = 0; nty = 0; }
      return {
        scale: ns,
        tx: LightboxZoom.clampPan(ntx, ns, w),
        ty: LightboxZoom.clampPan(nty, ns, h)
      };
    }
  };
  window.LightboxZoom = window.LightboxZoom || LightboxZoom;

  window.openLightbox = window.openLightbox || function(photos, startIdx, opts) {
    if (!photos || !photos.length) return;
    var esc = window.escHtml || function(s) { return String(s == null ? '' : s); };
    // 6.1n: kinds[i]==='plan' → белая подложка под кадр (прозрачные PNG Догмы на
    // тёмном backdrop лайтбокса иначе невидимы). Опционально — старые вызовы без
    // opts работают как раньше (фото на тёмном).
    var kinds = (opts && opts.kinds) || [];

    /* ──────────────────────────────────────────────────────────────────────
       СТЕНД: адрес кадра. На проде — дословно прежний, на копии сайта — свой.
       (доводка 2 блока 2.1 плана local-stand, 10.09.2026, VERIFY-2.1-3 P1-1)

       ⛔ ЧТО ЛЕЧИМ. Кадр лайтбокса ставился как есть — `esc(photos[idx])`.
       Массив кадров приходит от вызывающих сырым, и у 37 ЖК в базе в
       `image_url` лежит АБСОЛЮТНЫЙ `https://bronidom.ru/…` (находка 24).
       Итог замерен верификатором: клик по кадру на `/flat.php?id=15086353`
       давал 13 запросов наружу с локальной копии сайта, 11 из них — на
       БОЕВОЙ `bronidom.ru`. То есть «ноль наружу» держалось ровно до
       первого клика, а сторож этого не видел вовсе.

       ⛔ ПОЧЕМУ АДРЕС СЧИТАЕТ ВЫЗЫВАЮЩИЙ, А НЕ МЫ. Своего уменьшителя здесь
       нет намеренно: политика картинок и так живёт в пяти копиях (находка 30),
       шестая — худшее из решений. Вызывающий уже знает свою ширину кадра и
       свой уменьшитель, поэтому он передаёт готовую функцию в `opts.standSrc`.
       ⛔ Имя уменьшителя в этом файле не упоминается даже в комментарии: сторож
       (tests/Integration/local-stand-isolation.test.mjs) ищет его по всему файлу
       тупым поиском — и это его достоинство, а не придирка.

       ⛔ ПОЧЕМУ ЕЩЁ И ФЛАГ ЗДЕСЬ, ХОТЯ ОН УЖЕ ЕСТЬ У ВЫЗЫВАЮЩЕГО. Чтобы
       обещание «на проде кадр прежний» держалось на СВОЁМ замке, а не на
       чужой добросовестности: без `window.BRONIDOM_STAND === true` кадр —
       это `photos[idx]`, что бы вызывающий ни передал. Сравнение строгое:
       на проде флаг `false`, вне шаблона — `undefined`.
       Слово владельца 16.08 («увеличить показывает больше, чем на странице»)
       на проде не нарушается: там по-прежнему исходник.
       ────────────────────────────────────────────────────────────────────── */
    var standSrc = (window.BRONIDOM_STAND === true && opts && typeof opts.standSrc === 'function')
      ? opts.standSrc
      : function(u) { return u; };

    var reduce = typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var overlay = document.createElement('div');
    overlay.className = 'flat-lightbox';
    var idx = startIdx || 0;

    // Состояние зума текущего слайда.
    var state = { scale: 1, tx: 0, ty: 0 };
    var imgEl = null;
    var pointers = {};       // pointerId → {x,y} (для pinch/pan)
    var pinchStart = null;   // {dist, scale, cx, cy}
    var panStart = null;     // {x, y, tx, ty}
    var lastTap = 0;         // для double-tap

    function render() {
      overlay.innerHTML =
        '<div class="flat-lightbox-backdrop"></div>'
      + '<div class="flat-lightbox-content">'
      + '  <div class="flat-lightbox-stage">'
      + '    <img src="' + esc(standSrc(photos[idx])) + '" alt="" class="flat-lightbox-img' + (kinds[idx] === 'plan' ? ' flat-plan-img' : '') + '" draggable="false">'
      + '  </div>'
      + '  <button class="flat-lightbox-close" aria-label="Закрыть"><i class="fa-solid fa-xmark"></i></button>'
      + (photos.length > 1 ? '<button class="flat-lightbox-prev" aria-label="Назад"><i class="fa-solid fa-chevron-left"></i></button>' : '')
      + (photos.length > 1 ? '<button class="flat-lightbox-next" aria-label="Вперёд"><i class="fa-solid fa-chevron-right"></i></button>' : '')
      + '  <div class="flat-lightbox-zoom" role="group" aria-label="Масштаб">'
      + '    <button class="flat-lightbox-zoom-btn" data-zoom="out" aria-label="Уменьшить"><i class="fa-solid fa-minus"></i></button>'
      + '    <button class="flat-lightbox-zoom-btn" data-zoom="in" aria-label="Увеличить"><i class="fa-solid fa-plus"></i></button>'
      + '  </div>'
      + '  <div class="flat-lightbox-counter">' + (idx + 1) + ' / ' + photos.length + '</div>'
      + '</div>';
      imgEl = overlay.querySelector('.flat-lightbox-img');
      resetZoom();
    }

    // Размеры видимой картинки (для границ пана).
    function dims() {
      if (!imgEl) return { w: 0, h: 0 };
      var r = imgEl.getBoundingClientRect();
      // при уже применённом scale делим обратно — нужен базовый (1x) размер.
      return { w: r.width / state.scale, h: r.height / state.scale };
    }

    function applyTransform() {
      if (!imgEl) return;
      imgEl.style.transform =
        'translate(' + state.tx + 'px,' + state.ty + 'px) scale(' + state.scale + ')';
      imgEl.style.transition = reduce ? 'none'
        : (panStart || pinchStart ? 'none' : 'transform .18s ease');
      overlay.classList.toggle('is-zoomed', state.scale > 1);
    }

    function resetZoom() {
      state.scale = 1; state.tx = 0; state.ty = 0;
      applyTransform();
    }

    function zoomAt(factor, px, py) {
      var d = dims();
      var next = LightboxZoom.zoomToPoint(state, factor, px, py, d.w, d.h);
      state.scale = next.scale; state.tx = next.tx; state.ty = next.ty;
      applyTransform();
    }

    // px/py относительно центра сцены.
    function toCenterCoords(clientX, clientY) {
      var stage = overlay.querySelector('.flat-lightbox-stage');
      var r = (stage || overlay).getBoundingClientRect();
      return { x: clientX - (r.left + r.width / 2), y: clientY - (r.top + r.height / 2) };
    }

    function go(delta) {
      idx = (idx + delta + photos.length) % photos.length;
      render(); // ре-рендер сбрасывает зум нового слайда (границы/сцена заново)
    }

    render();
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    function closeLightbox() {
      overlay.remove();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    }

    function onKey(e) {
      if (e.key === 'Escape') { closeLightbox(); }
      else if (e.key === 'ArrowLeft') { go(-1); }
      else if (e.key === 'ArrowRight') { go(1); }
      else if (e.key === '+' || e.key === '=') { zoomAt(1.4, 0, 0); }
      else if (e.key === '-' || e.key === '_') { zoomAt(1 / 1.4, 0, 0); }
    }

    // Клики по кнопкам/фону.
    overlay.addEventListener('click', function(e) {
      if (e.target.closest('.flat-lightbox-close')) { closeLightbox(); return; }
      if (e.target.closest('.flat-lightbox-backdrop')) {
        if (state.scale > 1) { resetZoom(); } else { closeLightbox(); }
        return;
      }
      var zb = e.target.closest('.flat-lightbox-zoom-btn');
      if (zb) { zoomAt(zb.dataset.zoom === 'in' ? 1.4 : 1 / 1.4, 0, 0); return; }
      if (e.target.closest('.flat-lightbox-prev')) { go(-1); return; }
      if (e.target.closest('.flat-lightbox-next')) { go(1); return; }
    });

    // Колесо мыши = zoom к курсору.
    overlay.addEventListener('wheel', function(e) {
      if (!imgEl || !e.target.closest('.flat-lightbox-stage')) return;
      e.preventDefault();
      var c = toCenterCoords(e.clientX, e.clientY);
      zoomAt(e.deltaY < 0 ? 1.12 : 1 / 1.12, c.x, c.y);
    }, { passive: false });

    // Double-click / double-tap = быстрый 2x к точке (или сброс, если уже увеличено).
    overlay.addEventListener('dblclick', function(e) {
      if (!e.target.closest('.flat-lightbox-stage')) return;
      e.preventDefault();
      if (state.scale > 1) { resetZoom(); return; }
      var c = toCenterCoords(e.clientX, e.clientY);
      zoomAt(2, c.x, c.y);
    });

    // Pointer events: pan (1 палец/мышь при зуме) + pinch (2 пальца).
    overlay.addEventListener('pointerdown', function(e) {
      if (!e.target.closest('.flat-lightbox-stage')) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        var dist = Math.hypot(a.x - b.x, a.y - b.y);
        var mid = toCenterCoords((a.x + b.x) / 2, (a.y + b.y) / 2);
        pinchStart = { dist: dist || 1, scale: state.scale, cx: mid.x, cy: mid.y, tx: state.tx, ty: state.ty };
        panStart = null;
      } else if (ids.length === 1 && state.scale > 1) {
        panStart = { x: e.clientX, y: e.clientY, tx: state.tx, ty: state.ty };
      }
      // double-tap (touch)
      if (e.pointerType === 'touch') {
        var now = Date.now();
        if (now - lastTap < 300) {
          if (state.scale > 1) { resetZoom(); }
          else { var c = toCenterCoords(e.clientX, e.clientY); zoomAt(2, c.x, c.y); }
        }
        lastTap = now;
      }
    });

    overlay.addEventListener('pointermove', function(e) {
      if (!pointers[e.pointerId]) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (pinchStart && ids.length >= 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        var dist = Math.hypot(a.x - b.x, a.y - b.y);
        var factor = dist / pinchStart.dist;
        var target = LightboxZoom.clampScale(pinchStart.scale * factor);
        // зум к середине жеста (относительно старта пинча)
        var d = dims();
        var ns = target;
        var ntx = pinchStart.cx - (pinchStart.cx - pinchStart.tx) * (ns / pinchStart.scale);
        var nty = pinchStart.cy - (pinchStart.cy - pinchStart.ty) * (ns / pinchStart.scale);
        if (ns <= 1) { ntx = 0; nty = 0; }
        state.scale = ns;
        state.tx = LightboxZoom.clampPan(ntx, ns, d.w);
        state.ty = LightboxZoom.clampPan(nty, ns, d.h);
        applyTransform();
      } else if (panStart && state.scale > 1) {
        var d2 = dims();
        state.tx = LightboxZoom.clampPan(panStart.tx + (e.clientX - panStart.x), state.scale, d2.w);
        state.ty = LightboxZoom.clampPan(panStart.ty + (e.clientY - panStart.y), state.scale, d2.h);
        applyTransform();
      }
    });

    function endPointer(e) {
      delete pointers[e.pointerId];
      var n = Object.keys(pointers).length;
      if (n < 2) pinchStart = null;
      if (n === 0) panStart = null;
      applyTransform();
    }
    overlay.addEventListener('pointerup', endPointer);
    overlay.addEventListener('pointercancel', endPointer);
    overlay.addEventListener('pointerleave', endPointer);

    document.addEventListener('keydown', onKey);
  };

  // ── CSP: делегат [data-ym] для ymGoal (замена inline onclick) ──
  if (typeof document !== 'undefined') {
    document.addEventListener('click', function(e) {
      var el = e.target.closest('[data-ym]');
      if (el && window.ymGoal) window.ymGoal(el.dataset.ym);
    });
  }

})();
